import { CONFIG } from 'src/config-global';

/**
 * A path of the storefront as a whole address — what a search engine and a link preview need:
 * `/buy/bmw` → `https://<storefront>/buy/bmw`. The origin is the build's own (`CONFIG.storefrontUrl`,
 * derived from the one public domain), never the host a request happened to name: during a domain
 * move both hosts serve the page, and both must name the same address as its own.
 *
 * A build with no origin configured (a bare local one) answers the path itself.
 */
export const absoluteUrl = (path: string, origin: string = CONFIG.storefrontUrl): string =>
  `${origin.replace(/\/+$/, '')}${path.startsWith('/') ? path : `/${path}`}`;
